import { render } from "./pay-success.vue?vue&type=template&id=857645e0&scoped=true&ts=true"
import script from "./pay-success.vue?vue&type=script&lang=ts"
export * from "./pay-success.vue?vue&type=script&lang=ts"

import "./pay-success.vue?vue&type=style&index=0&id=857645e0&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-857645e0"]])

export default __exports__